import type { PathObjectInterface } from '@/map-phaser-new/interfaces'

export const helicopterLeftToRightPath: PathObjectInterface = {
  mainPath: { x: -10, y: 817 },
  spline: [
    657, 959, 947, 1091, 1675, 964, 2095, 906, 2882, 872, 3230, 719, 3563, 479, 3753, 424, 3880,
    414,
  ],
}
